import type { Route } from '../admin-fetch';
import { callServer } from '../server';
import { bodyOf, failure } from '../respond';

// Sign in / out. The server sets and clears the session cookie itself.
export const authRoutes: Route[] = [
  ['POST', '/api/auth', async (req) => {
    const { email, password } = await bodyOf<{ email?: string; password?: string }>(req);
    const result = await callServer('POST', '/api/v1/admin/session', { body: { email, password } });
    if (!result.ok) return failure(result);
    return Response.json({ success: true });
  }],
  ['DELETE', '/api/auth', async () => {
    await callServer('DELETE', '/api/v1/admin/session');
    return Response.json({ success: true });
  }],
];
